import { normalizeWorkBuddyGroups } from '../workBuddyAuthorize/workBuddyAuthorize.utils'

// 对齐桌面端 layout/credits.ts 与 membership/config.ts，档位数字不是等级顺序。
export function membershipPurchaseOptions(info: {
  is_vip?: boolean
  vip_info?: { vip_kind?: number }
}) {
  const kind = info.is_vip ? info.vip_info?.vip_kind || 0 : 0
  const names: Record<number, string> = {
    0: '非会员',
    1: '基础会员',
    3: '高级会员',
    2: '超级会员',
    4: '企业级会员'
  }
  return {
    kind,
    label: names[kind] || '会员状态未知',
    canBuyPack: [2, 3, 4].includes(kind),
    upgradeKind: kind === 0 ? 1 : kind === 1 ? 3 : kind === 3 ? 2 : null
  }
}

export const isWorkBuddyMembershipPath = (path: string): boolean =>
  path.toLowerCase().replace(/\/+$/, '') === '/workbuddy/membership'

// 不回落到浏览器中上次选中的团队，避免给其他团队购买。
export const resolveMembershipGroup = (groups: unknown, search: string) => {
  const id = new URLSearchParams(search).get('groupId')?.trim()
  if (!id) return undefined
  return normalizeWorkBuddyGroups(groups).find(
    (group) => group.id === id || group.inviteId === id
  )
}

export const membershipBindURL = (search: string, code: string): string => {
  const query = new URLSearchParams(search)
  query.delete('code')
  query.delete('state')
  query.set('token', code)
  query.set('bind', '1')
  return `/workbuddy/membership?${query}`
}
